import BaseBlockContent from '@sanity/block-content-to-react';
import React from 'react';
import clientConfig from '../../../client-config';
import serializers from './serializers';

const BlockContent = ({ blocks, className }) => <BaseBlockContent blocks={blocks} className={className} serializers={serializers} {...clientConfig.sanity} />;

// https://www.sanity.io/docs/presenting-block-text#plain-text-serialization-ac67a867dd69
export function toPlainText(blocks = []) {
  return (
    blocks
      .map(block => {
        if (block._type !== 'block' || !block.children) {
          return '';
        }
        return block.children.map(child => child.text).join('');
      })
      .join('\n\n')
  );
}

export default BlockContent;
